module.exports = __webpack_public_path__ + "img/dropsmith drop.2a2a551b.svg";